// frontend/admin-portal/src/pages/Roles.jsx
import React, { useEffect, useState, useCallback } from "react";
import { PageHeader, Button, Alert, Spinner, Can } from "@fiberhome/shared-ui";
import { roleService } from "../services/roleService";
import RoleCard from "../components/users/RoleCard";
import RoleModal from "../components/users/RoleModal";

export default function Roles() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setItems(await roleService.list());
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleNew = () => {
    setEditing(null);
    setModalOpen(true);
  };
  const handleEdit = (r) => {
    setEditing(r);
    setModalOpen(true);
  };

  const handleDuplicate = async (r) => {
    try {
      await roleService.duplicate(r.id);
      load();
    } catch (err) {
      alert(err.response?.data?.message || err.message);
    }
  };

  const handleDelete = async (r) => {
    if (!window.confirm(`Delete role "${r.displayName}"?`)) return;
    try {
      await roleService.remove(r.id);
      load();
    } catch (err) {
      alert(err.response?.data?.message || err.message);
    }
  };

  return (
    <>
      <PageHeader
        title="Roles"
        subtitle="Define what each type of user can do"
        breadcrumbs={["Home", "Roles"]}
        actions={
          <Can permission="roles.write">
            <Button variant="primary" onClick={handleNew}>
              + New Role
            </Button>
          </Can>
        }
      />

      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      {loading ? (
        <div className="fh-settings-loading">
          <Spinner size="lg" />
        </div>
      ) : (
        <div className="row g-3">
          {items.map((r) => (
            <div className="col-lg-4 col-md-6" key={r.id}>
              <RoleCard
                role={r}
                onEdit={handleEdit}
                onDuplicate={handleDuplicate}
                onDelete={handleDelete}
              />
            </div>
          ))}
        </div>
      )}

      <RoleModal
        open={modalOpen}
        role={editing}
        onClose={() => setModalOpen(false)}
        onSaved={load}
      />
    </>
  );
}
